import { render, staticRenderFns } from "./TextFieldtype.vue?vue&type=template&id=1194f746&"
import script from "./TextFieldtype.vue?vue&type=script&lang=js&"
export * from "./TextFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports